<template>
    <form id="onboarding-de" class="wrapper tab-email" role="form" method="post" @submit.prevent="submit" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Möchten Sie mehr Informationen per Mail erhalten? </span>

            <p class="new-text-lg text-centered text-color-default">Registrieren Sie sich hier für unseren Newsletter.</p>
        </header>

        <div class="form-wrapper">
            <div class="col-2">
                <form-input-type-text
                    name="first_name"
                    label="Vorname"
                    :errors="errors.first_name"
                    full-border
                    required
                ></form-input-type-text>

                <form-input-type-text
                    name="last_name"
                    label="Nachname"
                    :errors="errors.last_name"
                    full-border
                    required
                ></form-input-type-text>
            </div>

            <form-input-type-email
                name="email"
                label="E-Mail-Adresse"
                :errors="errors.email"
                required
                full-border
            ></form-input-type-email>

            <p class="form-mandatory-fields">* Felder mit Sternchen (*) sind Pflichtfelder.</p>
        </div>

        <p class="new-text-md text-centered">Mit Ihrer Registrierung stimmen Sie der Verarbeitung Ihrer Daten für den Erhalt unseres Newsletters zu. Weitere Informationen zu der Verarbeitung finden Sie in unseren <a href="/datenschutzerklarung">Datenschutzrichtlinien</a>.</p>

        <div class="btn-group">
            <v-button type="submit" label="Senden" full-width></v-button>
            <v-button label="Überspringen" @onClick="skip" variant="secondary" full-width></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            learntAboutVitadioFrom: {
                type: String,
                required: false,
                default: null
            },
        },

        data() {
            return {
                errors: {},
                data: {}
            }
        },

        mounted() {
        },

        watch: {
        },

        methods: {
            submit() {
                let that = this
                this.data.name = $("#first_name").val() + " " + $("#last_name").val()
                this.data.email = $("#email").val()
                this.data.ga_client_id = null
                this.data.gcl_id = null
                this.data.agreements = true
                //this.data.learnt_about_vitadio_from = this.learntAboutVitadioFrom

                let gaCookie = window.getCookie("_ga")
                let gclCookie = window.getCookie("_gcl_aw")

                if(gaCookie !== "" && gaCookie !== "undefined") {
                    this.data.ga_client_id = gaCookie
                }

                if((gclCookie !== "undefined" && gclCookie !== "") && this.data.ga_client_id === gaCookie) {
                    this.data.gcl_id = gclCookie
                }

                axios
                    .post('api/web_pre_registration_form', this.data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', 'thanks')
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors

                        if(!$("#first_name").val()) {
                            this.errors.first_name = ['Vorname muss eingetragen werden.']
                        }

                        if(!$("#last_name").val()) {
                            this.errors.last_name = ['Nachname muss eingetragen werden.']
                        }

                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            skip() {
                setTimeout(() => {
                    this.$emit('clicked', 'call')
                }, 250);
            }
        }
    }
</script>
